import styled from 'styled-components';
import LogoImage from '../../../assets/images/logo-black.svg';
import colors from '../../../modules/core/constants/Colors';

export const Header = styled.header`
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  height: 88px;
  padding: 24px 32px;
  box-sizing: border-box;
  @media screen and (max-width: 767px) {
    height: 56px;
    padding: 12px 24px;
  }
`;

export const Logo = styled(LogoImage)`
  @media screen and (max-width: 767px) {
    width: 64px;
  }
`;

export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${colors.blueyGrey};
  position: relative;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 16px;
  }

  @media screen and (max-width: 767px) {
    width: 32px;
    height: 32px;
  }
`;
